<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết ticket</h1>
      <div>
        <div class="btn-group mr-2">
          <button
            v-if="
              canInitAppendix(item.status, item.processUserSupervisor, item.processUserReceiver)
            "
            @click="initAppendix()"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Yêu cầu hỗ trợ lên phụ lục
          </button>
        </div>
        <button @click="showRefundInfoModal()" class="f12 font-medium btn btn-outline-secondary">
          Lấy thông tin người nhận hoàn tiền
        </button>
        <div class="btn-group mr-2">
          <button
            v-if="
              item.isManualUpdate === true &&
              item.processUserSupervisor &&
              this.dataUser.userId == item.processUserSupervisor.userId
            "
            @click="editManagerInfo()"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Sửa TT quản lý
          </button>
        </div>
        <div class="btn-group mr-2">
          <button @click="showModalMaker()" class="f12 font-medium btn btn-outline-secondary">
            Đánh dấu đã gán TB cho MC
          </button>
        </div>
        <div class="btn-group mr-2">
          <button @click="showModalDeviceAssMC()" class="f12 font-medium btn btn-outline-secondary">
            Chọn TB gán cho MC
          </button>
        </div>
        <div class="btn-group mr-2">
          <button
            @click="editItem(item.ticketId)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Cập nhật
          </button>
        </div>
        <div class="btn-group">
          <button
            @click="$router.push('/ticket')"
            class="f12 font-medium btn btn-outline-secondary"
          >
            <i class="bx bx-left-arrow-alt"></i> Quay lại
          </button>
          <button
            @click="changStatus(item, 'Đóng hủy')"
            v-if="canCancel(item.status, item.processUserSupervisor, item.userRelation)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Huỷ
          </button>
          <button
            @click="changStatus(item, 'Hoàn thành')"
            v-if="canComplete(item.status, item.processUserSupervisor, item.userRelation)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Hoàn thành
          </button>
          <button
            @click="changStatus(item, 'Tạm hoãn')"
            v-if="canPending(item.status, item.processUserSupervisor, item.userRelation)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Tạm hoãn
          </button>
          <button
            @click="newItem(item)"
            v-if="canNew(item.status, item.processUserSupervisor, item.userRelation)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Quay về mới tạo
          </button>
          <button
            @click="processingItem(item)"
            v-if="
              canProcessing(
                item.status,
                item.isManualUpdate,
                item.processUserSupervisor,
                item.processUserReceiver
              )
            "
            class="f12 font-medium btn btn-outline-secondary"
          >
            Bắt đầu xử lý
          </button>
          <button
            v-if="
              canEdit(
                item.status,
                item.processUserSupervisor,
                item.isManualUpdate,
                item.processUserReceiver
              )
            "
            @click="editItem(item.ticketId)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Sửa
          </button>
          <button
            v-if="
              canStart(
                item.status,
                item.isManualUpdate,
                item.processUserSupervisor,
                item.processUserReceiver
              )
            "
            @click="
              selectedTicket = [item.ticketId]
              startItem()
            "
            class="f12 font-medium btn btn-outline-secondary"
          >
            Bắt đầu xử lý
          </button>
          <button
            v-if="
              item.status === 'PROCESSING' &&
              ['ONBOARD_OFFLINE_MPOS', 'ONBOARD_ONLINE_MPOS'].includes(item.typeCode)
            "
            @click="processTicketWithWorkflow(item.ticketId)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Xử lý ticket
          </button>
          <button
            v-if="callioConfig.active === true && item.status === 'PROCESSING'"
            @click="processTicketWithCallio(item.merchantInfo, item.ticketId, item.typeCode)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Gọi điện
          </button>
          <button @click="openModalCallResult()" class="f12 font-medium btn btn-outline-secondary">
            Kết quả gọi
          </button>
        </div>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-4 pr-2">
          <div class="form-detail">
            <h1>Thông tin merchant</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo && item.merchantInfo.merchantName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo.mobile | encryptPhone }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Email<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo && item.merchantInfo.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo ? item.merchantInfo.address : '' }}
                  {{ item.merchantInfo ? item.merchantInfo.city : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Vùng MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.bizLocation ? item.bizLocation.regionName : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Điểm bán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    item.bizLocation
                      ? `${item.bizLocation.areaName} - ${item.bizLocation.areaAddress} - ${item.bizLocation.areaDistrict} -
                  ${item.bizLocation.city}`
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Email sale phụ trách<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.saleInfo ? item.saleInfo.email : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngành nghề<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo ? item.merchantInfo.mccName : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngành nghề chi tiết<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo ? item.merchantInfo.mccDetail : '' }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin phân loại</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Dịch vụ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.productName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Nhóm ticket<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.groupName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Danh mục ticket<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.typeName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tiểu mục ticket<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.subTypeName }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin mô tả</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Nguồn báo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.sourceInform | transformData(Config.ticketSource) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thời gian báo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.informAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Hình thức báo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.informMethod | transformData(Config.informMethod) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã tham chiếu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.referenceId }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mô tả cụ thể<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item?.detail ? item?.detail : '' }} {{ item.content }}
                </p>
              </div>
            </div>
            <!-- <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Mã giao dịch<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.referenceId }}</p>
              </div>
            </div> -->
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã sản phẩm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.productName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã thiết bị<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.deviceCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG mong muốn hoàn thành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.desiredCompleteTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã nhóm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.groupName }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin xử lý</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="item.status">
                    {{ item.status | transformData(Config.ticketStatus) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Hiện trạng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p v-if="item.currentStateCode === 'OTHER'" class="form-control-plaintext f12">
                  Khác ({{ item.currentState }})
                </p>
                <p v-else class="form-control-plaintext f12">
                  {{ item.currentState }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại kết quả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.result }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG hoàn thành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.completeTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG huỷ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.cancelTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.rejectTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người tiếp nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.nameProcessUserReceiver }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người giám sát<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.nameProcessUserSupervisor }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người theo dõi<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.nameProcessUserFollowers }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin quản lý</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Bộ phận vừa xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.workUnitText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Bộ phận đang xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.workingUnitText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mức độ ưu tiên<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.workPriorityText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.workTypeText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thời hạn bước hiện tại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.workingStepTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thời hạn ticket<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.ticketDeadline | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin Bảo hành</h1>
            <div v-if="item.deviceError" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thiết bị bảo hành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.deviceError.serial }}
                </p>
              </div>
            </div>
            <div v-if="item.deviceTest" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thiết bị test cho MC mượn<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.deviceTest.serial }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Đánh dấu đã gán TB test {{ item.assNewTestDevice
                }}<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    item.assNewTestDevice && item.assNewTestDevice === true ? 'Đã gán' : 'Chưa gán'
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Đánh dấu đã gán TB bàn giao thay thế {{ item.assReplaceDevice
                }}<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    item.assReplaceDevice && item.assReplaceDevice === true ? 'Đã gán' : 'Chưa gán'
                  }}
                </p>
              </div>
            </div>
            <div v-if="item.deviceChange" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thiết bị bàn giao thay thế<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.deviceChange.serial }}
                </p>
              </div>
            </div>
            <div v-if="item.idContractMpos" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thông tin TPV Merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12 detail"
                  @click="linkTPVMerchant(item.idContractMpos, 1)"
                >
                  Link chi tiết
                </p>
              </div>
            </div>
            <div v-if="item.idContractElec" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Phiếu bảo hành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12 detail"
                  @click="linkTPVMerchant(item.idContractElec, 2)"
                >
                  Link chi tiết
                </p>
              </div>
            </div>
            <div v-if="item.idContractPaper" class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Phụ lục hợp đồng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12 detail"
                  @click="linkTPVMerchant(item.idContractPaper, 3)"
                >
                  Link chi tiết
                </p>
              </div>
            </div>
          </div>

          <div class="form-detail" v-if="item.typeCode === 'CTGROUP' && item.data.transactions">
            <h1>Thông tin thêm</h1>
            <div class="table-responsive text-center p-0">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col"><b>Thời gian</b></th>
                    <th scope="col"><b>Mã giao dịch</b></th>
                    <th scope="col"><b>Số tiền</b></th>
                    <th scope="col"><b>Chủ thẻ</b></th>
                    <th scope="col"><b>Số thẻ</b></th>
                    <th scope="col"><b>Loại thẻ</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-row"
                    v-for="(transaction, index) in item.data.transactions"
                    :key="index"
                  >
                    <td class="text-center">{{ transaction.createdDate }}</td>
                    <td class="text-center">
                      {{ transaction.transactionTxnId }}
                    </td>
                    <td class="text-center">
                      {{ transaction.transactionAmount }}
                    </td>
                    <td class="text-center">{{ transaction.cardName }}</td>
                    <td class="text-center">{{ transaction.cardNumber }}</td>
                    <td class="text-center">{{ transaction.cardTypeText }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-detail">
            <h1>Lịch sử</h1>
            <div class="table-responsive text-center p-0">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col"><b>Thời gian</b></th>
                    <th scope="col"><b>Người thực hiện</b></th>
                    <th scope="col"><b>Hiện trạng</b></th>
                    <th scope="col"><b>Link</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(data, index) in item.actionHistory" :key="index">
                    <td class="text-center">
                      {{ data.actionAt | formatDate('HH:mm, DD/MM/YYYY') }}
                    </td>
                    <td class="text-center">
                      {{ data.actionByEmail }} <br />
                      <span v-if="data.source">Nguồn: {{ data.source }}</span>
                    </td>
                    <td class="text-center">
                      {{ data.actionVale }}<br /><span v-if="data.actionResult"
                        >Kết quả: {{ data.actionResult }}</span
                      ><br />
                      <span v-if="data.currentStateCode === 'OTHER'"
                        >Hiện trạng: Khác({{ data.currentState }})</span
                      >
                      <span v-else>Hiện trạng: {{ data.currentState }}</span>
                    </td>
                    <td class="text-center detail">
                      <u v-if="data.link" @click="viewDetail(data.link)">Chi tiết</u>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-4 pr-2">
          <div class="form-detail">
            <h1>Thông tin cuộc gọi</h1>
            <div class="table-responsive text-center p-0">
              <b-table
                striped
                hover
                :items="historyCall"
                :fields="historyCallFields"
                thead-class="thead-light"
                sticky-header="500px"
                responsive
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(toNumber)="data">
                  <strong>{{ data.item.toNumber | encryptPhone }}</strong
                  ><br />{{ data.item.contactName }}
                </template>
                <template #cell(username)="data">
                  <strong>{{ data.item.username }}</strong
                  ><br />{{ data.item.userEmail }}
                </template>
                <template #cell(initCallIoTime)="data">
                  {{ data.item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(createCallIoTime)="data">
                  {{ data.item.createCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}<br />
                  {{ data.item.endCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(timing)="data">
                  {{ getTiming(data.item.endCallIoTime, data.item.createCallIoTime) }}
                </template>
                <template #cell(direction)="data">
                  {{ data.item.direction | formatDirection }}
                </template>
                <template #cell(crmResult)="data">
                  <span v-if="data.item.crmResult"
                    >{{ data.item.crmResult | resultCall(resultStatusCalls) }}
                    <br />
                    {{ data.item.crmNote }}
                  </span>
                </template>
                <template #cell(action)="data">
                  <b-dropdown class="text-center" variant="outline-light">
                    <b-dropdown-item @click="detailCall(data.item.id)" class="dropdown-item"
                      ><span>&nbsp;</span>Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.callId"
                      @click="listenRecord(data.item.callId)"
                      class="dropdown-item"
                      ><span>&nbsp;</span>Nghe ghi âm cuộc gọi
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
          <div class="form-detail" v-if="item.typeCode === 'DENY_INSTALLMENT'">
            <h1>Thông tin giao dịch trả góp</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.mc_trans_id"
                >
                  {{ item.data.transaction.mc_trans_id }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngày giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.transaction_date"
                >
                  {{ formatTimestamp(item.data.transaction.transaction_date) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.trans_amount"
                >
                  {{ item.data.transaction.trans_amount | fomatCurrency }} (VNĐ)
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Phương thức thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.tran_type"
                >
                  {{ item.data.transaction.tran_type }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái trả góp<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.status"
                >
                  <!-- {{ item.data.transaction.status }} -->
                  {{ getNameStatus(item.data.transaction.status) }}
                </p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="item.data.rejection_reason && item.data.rejection_reason.reason_group"
            >
              <label class="col-sm-4 col-form-label"
                >Nhóm lý do từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data.rejection_reason.reason_group }}
                </p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="item.data.rejection_reason && item.data.rejection_reason.description"
            >
              <label class="col-sm-4 col-form-label"
                >Lý do từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data.rejection_reason.description }}
                </p>
              </div>
            </div>
            <div
              v-if="item.data?.actions && item.data?.actions[0]?.attributes"
              class="form-group form-row"
            >
              <label class="col-sm-4 col-form-label"
                >MC cần cung cấp<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data?.actions[0]?.attributes?.flatMap(i => i.description).join(', ') }}
                </p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="item.data.rejection_reason && item.data.rejection_reason.help_action"
            >
              <label class="col-sm-4 col-form-label"
                >Hướng xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12 reason-text">
                  {{ item.data.rejection_reason.help_action }}
                </p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="item.data.rejection && item.data.rejection.VhNote"
            >
              <label class="col-sm-4 col-form-label"
                >VH ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data.rejection.VhNote }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="item.data?.VhNote">
              <label class="col-sm-4 col-form-label"
                >VH ghi chú bổ sung<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data?.VhNote }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="item.data?.mcNote">
              <label class="col-sm-4 col-form-label"
                >MC ghi chú bổ sung<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data?.mcNote }}
                </p>
              </div>
            </div>
            <div class="form-group form-row px-1" v-if="item.data?.attributeValues">
              <div class="col-sm-12 form-detail custom-table">
                <h1 style="font-size: 12px">Trường thuộc tính</h1>
                <b-table
                  striped
                  hover
                  :items="JSON.parse(item?.data?.attributeValues) || []"
                  :fields="attributeValuesFields"
                  thead-class="thead-light"
                  sticky-header="500px"
                  responsive
                  show-empty
                  empty-text="Không có dữ liệu!"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="item.typeCode === 'CCCT_BANK_SCAN'">
            <h1>Thông tin giao dịch</h1>
            <div class="table-responsive text-center p-0">
              <b-table
                striped
                hover
                :items="item?.data?.transactions || []"
                :fields="transactionsFields"
                thead-class="thead-light"
                sticky-header="500px"
                responsive
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ data.item.amount | transformMoney }}
                </template>
                <template #cell(createdDate)="data">
                  {{ data.item.createdDate | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
              </b-table>
            </div>
          </div>
          <div class="form-detail" v-if="item.typeCode === 'QR_TIMEOUT'">
            <h1>Thông tin giao dịch QA timemout</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TRXID NCC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.bankTransId">
                  {{ item.data.bankTransId }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số tiền giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.amount">
                  {{ item.data.amount | transformMoney }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngày giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.transDate">
                  {{ convertTimestampToDateText(item.data.transDate) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="item.data?.mposUserId">
              <label class="col-sm-4 col-form-label"
                >mposUserId<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data.mposUserId }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="item.data?.mposUserMobile">
              <label class="col-sm-4 col-form-label"
                >mposUserMobile<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.data.mposUserMobile }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="item?.merchantInfo?.mposMerchantId">
              <label class="col-sm-4 col-form-label"
                >mposMerchantId<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantInfo.mposMerchantId }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="item.typeCode === 'CCCT'">
            <h1>Thông tin giao dịch</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data && item.data.transactionTxnId"
                >
                  {{ item.data.transactionTxnId ? item.data.transactionTxnId : '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số tiền giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data && item.data.transactionAmount"
                >
                  {{ item.data.transactionAmount | transformMoney }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data && item.data.transactionTypeText"
                >
                  {{ item.data.transactionTypeText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Phương thức thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data && item.data.paymentMethodText"
                >
                  {{ item.data.paymentMethodText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data && item.data.transactionStatusText"
                >
                  {{ item.data.transactionStatusText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại rủi ro<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.riskTypeText">
                  {{ item.data.riskTypeText }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="item.typeCode === 'CCCT'">
            <h1>Thông tin chủ thẻ</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Tên<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.cardName">
                  {{ item.data.cardName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.cardNumber">
                  {{ item.data.cardNumber }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12" v-if="item.data && item.data.cardTypeText">
                  {{ item.data.cardTypeText }}
                </p>
              </div>
            </div>
          </div>

          <div class="form-detail" v-if="item.typeCode === 'DENY_INSTALLMENT'">
            <h1>Thông tin thẻ</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên chủ thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.card_name"
                >
                  {{ item.data.transaction.card_name }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.card_number"
                >
                  {{ item.data.transaction.card_number }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Ngân hàng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="item.data.transaction && item.data.transaction.bank_code"
                >
                  {{ item.data.transaction.bank_code }}
                </p>
              </div>
            </div>
          </div>
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Thông tin ảnh</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in item.ticketImages" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="img-list-wrapper">
            <div class="row align-items-center">
              <h1 class="form-inner-heading col-7 col-md-8 col-lg-4 mb-3 mb-md-0">
                Ảnh hiện trường
              </h1>
              <b-button
                variant="outline-primary"
                class="col-4 col-md-4 col-lg-3 mb-2 mb-md-0"
                @click.prevent="handleClick"
                size="md"
                v-if="item.status == 'PROCESSING'"
              >
                Thêm ảnh
              </b-button>
            </div>
          </div>

          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Ảnh checkin</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer v-if="item.checkInImage">
                    <li v-for="(itemCheckIn, index) in item.checkInImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="itemCheckIn" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Ảnh tác nghiệp</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer v-if="item.operationalImage">
                    <li v-for="(imgOperational, index) in item.operationalImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="imgOperational" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="img-list-wrapper">
            <h1 class="form-inner-heading test">Ảnh checkouthhh</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer v-if="item.checkOutImage">
                    <li v-for="(itemCheckOut, index) in item.checkOutImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="itemCheckOut" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Ảnh xác thực</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer v-if="item.explanationImage">
                    <li v-for="(imgConfirm, index) in item.explanationImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="imgConfirm" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SelectEmployee @selectSale="onSelectSale" />
    <ChangeStatusTicket
      v-if="showChangeStatusTicket"
      @updateStatus="updateStatus"
      :dataResult="dataResult"
      :ticketId="ticketId"
      :checkResult="checkResult"
      :typeCode="typeCode"
    />
    <ModalInitAppendix
      v-if="showModalInitAppendix"
      @updateInfo="updateInfo"
      :infoSale="infoSale"
      :dataOption="dataOption"
      :closeModalRequestDevice="closeModalRequestDevice"
    />
    <modalDeviceAssMC
      v-if="showDeviceAssMC"
      @updateInfoDeviceAssMC="updateInfoDeviceAssMC"
      :ticketId="this.item.ticketId"
      :closeModal="closeModal"
    />
    <modalMakerDeviceAss
      v-if="showModalMakerDeviceAss"
      @updateInfoMakerDevice="updateInfoMakerDevice"
      :ticketId="this.item.ticketId"
      :closeModalMaker="closeModalMaker"
      :dataMakerDevice="this.dataMakerDevice"
      :emailMC="this.item.merchantInfo.email"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <!-- 2. Thêm modal vào cuối template (trước VueLoadingOverlay) -->
    <b-modal
      id="refund-info-modal"
      ref="refundInfoModal"
      title="Thông tin người nhận hoàn tiền"
      size="md"
      hide-footer
      @hidden="resetRefundForm"
    >
      <form @submit.prevent="submitRefundInfo">
        <div class="form-group">
          <label for="refundStatus">Trạng thái <span class="text-danger">*</span></label>
          <SearchStaffAutocomplete
            :maxShow="20"
            v-model="refundForm.status"
            :list="listStatus"
            placeholder="Chọn trạng thái"
          />
        </div>

        <div class="form-group" v-if="refundForm.status === 'SUCCESS'">
          <label for="accountNo">Số tài khoản <span class="text-danger">*</span></label>
          <input
            id="accountNo"
            v-model="refundForm.accountNo"
            type="text"
            class="form-control"
            placeholder="Nhập số tài khoản"
            maxlength="20"
            required
          />
        </div>

        <div class="form-group" v-if="refundForm.status === 'SUCCESS'">
          <label for="bankSelect">Ngân hàng <span class="text-danger">*</span></label>
          <SearchStaffAutocomplete
            size="md"
            :maxShow="20"
            v-model="refundForm.bankId"
            :list="bankOptions"
            placeholder="Chọn ngân hàng"
          />
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary mr-2" @click="closeRefundModal">
            Hủy
          </button>
          <button type="submit" class="btn btn-primary" :disabled="!isRefundFormValid">
            Xác nhận
          </button>
        </div>
      </form>
    </b-modal>
    <ModalCallResult ref="refModalCallResult" />
  </div>
</template>

<script>
  import pad from 'lodash/pad'
  import { CallIoService } from '@/services/callio.service'
  import { TicketService } from '@/services/ticket.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import mxItemAction from './mx-item-action.js'
  import ChangeStatusTicket from '@/components/ChangeStatusTicket.vue'
  import moment from 'moment'
  import ModalInitAppendix from './modal-init-appendix.vue'
  import modalDeviceAssMC from './modal-device-ass-mc.vue'
  import modalMakerDeviceAss from './modal-maker-device-ass.vue'
  import { CommonService } from '@/services/common.service'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import ModalCallResult from './ModalCallResult.vue'

  export default {
    name: 'detail-ticket',
    mixins: [mxItemAction],
    components: {
      ChangeStatusTicket,
      ModalInitAppendix,
      modalDeviceAssMC,
      modalMakerDeviceAss,
      SearchStaffAutocomplete,
      ModalCallResult,
    },

    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        isEdit: false,
        Config,
        item: {},
        showLoading: false,
        dataResult: [],
        ticketId: '',
        checkResult: '',
        showChangeStatusTicket: false,
        showModalInitAppendix: false,
        showModalMakerDeviceAss: false,
        showDeviceAssMC: false,
        typeCode: '',
        resultStatusCalls: [],
        historyCall: [],
        transactionsFields: [
          { key: 'txid', label: 'Mã giao dịch' },
          { key: 'amount', label: 'Số tiền giao dịch' },
          { key: 'transactionTypeText', label: 'Loại giao dịch' },
          { key: 'paymentMethod', label: 'Phương thức thanh toán' },
          { key: 'status', label: 'Trạng thái giao dịch' },
          { key: 'cardholderName', label: 'Tên chủ thẻ' },
          { key: 'pan', label: 'Số thẻ' },
          { key: 'reason', label: 'Lý do tra soát' },
        ],
        attributeValuesFields: [
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'value', label: 'Value' },
        ],
        historyCallFields: [
          { key: 'toNumber', label: 'Liên hệ' },
          { key: 'username', label: 'Nhân sự' },
          { key: 'initCallIoTime', label: 'TG khởi tạo' },
          { key: 'createCallIoTime', label: 'TG thực hiện' },
          { key: 'timing', label: 'TG gọi' },
          { key: 'direction', label: 'Chiều gọi' },
          { key: 'crmResult', label: 'Kết quả' },
          { key: 'action', label: 'Thao tác', fixIndex: 999 },
        ],
        infoSale: {},
        dataOption: [],
        isMobile: false,
        dataMakerDevice: {},
        statusData: [
          {
            id: 'NEW',
            text: 'Mới tạo',
          },
          {
            id: 'APPROVED',
            text: 'Đã duyệt chuyển đổi trả góp',
          },
          {
            id: 'MANUAL_SEND',
            text: 'Đã gửi thủ công',
          },
          {
            id: 'SENT',
            text: 'Đã gửi tự động',
          },
          {
            id: 'SEND_FAILED',
            text: 'Gửi chuyển đổi trả góp thất bại',
          },
          {
            id: 'BANK_FAIL',
            text: 'Gửi trả góp sang ngân hàng thất bại',
          },
          {
            id: 'SUCCESS',
            text: 'Gửi thành công',
          },
          {
            id: 'WITHDRAW',
            text: 'Đã thanh toán',
          },
          {
            id: 'FAILED',
            text: 'Ngân hàng từ chối trả góp',
          },
          {
            id: 'ON_HOLD',
            text: 'Tạm giữ chuyển đổi trả góp',
          },
          {
            id: 'CANCEL',
            text: 'Hủy trả góp',
          },
        ],
        showRefundModal: false,
        refundForm: {
          status: '',
          accountNo: '',
          bankId: '',
          bankName: '',
        },
        bankOptions: [],
        listStatus: [
          { id: 'SUCCESS', text: 'Thành công' },
          { id: 'FAILED', text: 'Không thành công' },
        ],
      }
    },

    mounted() {
      this.checkIsMobile()
      window.addEventListener('resize', this.checkIsMobile)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkIsMobile)
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getNameStatus() {
        return status => {
          return this.statusData.find(item => item.id === status).text || status
        }
      },
      isRefundFormValid() {
        if (this.refundForm.status === 'FAILED') {
          return true
        }
        return this.refundForm.accountNo && this.refundForm.bankId
      },
    },
    async created() {
      try {
        this.showLoading = true
        await this.fetchData()
        await this.fetchResult()
        await this.fetchResultStatusCall()
        await this.fetchHistory()
        await this.fetchUserSupervisor()
        this.getConfigSystem()
        this.selectedTicket = [this.item.ticketId]
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },

    methods: {
      openModalCallResult() {
        this.$refs.refModalCallResult.openModal(this.item.ticketId)
      },
      convertTimestampToDateText(timestamp) {
        return moment.unix(timestamp).format('DD/MM/YYYY, HH:mm:ss')
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data
              this.bankOptions =
                config.banks.map(bank => ({ id: bank.code, text: bank.name, ...bank })) || []
            }
          })
          .catch(error => console.log(error))
      },

      showRefundInfoModal() {
        this.showRefundModal = true
        this.$nextTick(() => {
          this.$bvModal.show('refund-info-modal')
        })
      },

      closeRefundModal() {
        this.$bvModal.hide('refund-info-modal')
        this.showRefundModal = false
      },

      resetRefundForm() {
        this.refundForm = {
          status: '',
          accountNo: '',
          bankId: '',
          bankName: '',
        }
      },

      async submitRefundInfo() {
        if (!this.isRefundFormValid) {
          this.showFailMx('Vui lòng điền đầy đủ thông tin')
          return
        }

        try {
          this.showLoading = true

          const selectedBank = this.bankOptions.find(bank => bank.id === this.refundForm.bankId)
          this.refundForm.bankName = selectedBank ? selectedBank.text : ''

          const requestData = {
            status: this.refundForm.status,
            ticketId: this.item.ticketId,
            accountNo: this.refundForm.accountNo,
            bankId: this.refundForm.bankId,
            bankName: this.refundForm.bankName,
          }

          const response = await CallIoService.updateTickkitBankAcount(requestData)
          if (response.code === 1000) {
            // Giả lập thành công
            this.showSuccessMx('Cập nhật thông tin hoàn tiền thành công')
            this.closeRefundModal()
            await this.fetchData() // Refresh dữ liệu
          } else {
            this.showFailMx(response.message || 'Có lỗi xảy ra khi cập nhật thông tin hoàn tiền')
          }
        } catch (error) {
          console.error('Lỗi khi gửi thông tin hoàn tiền:', error)
          this.showFailMx('Có lỗi xảy ra khi cập nhật thông tin hoàn tiền')
        } finally {
          this.showLoading = false
        }
      },
      formatTimestamp(timestamp) {
        return moment.unix(timestamp).format('DD/MM/YYYY HH:mm')
      },
      async listenRecord(id) {
        this.showLoading = true
        try {
          const res = await CallIoService.getRecording(id)
          window.open(res.data.url, '_blank')
        } catch (error) {
        } finally {
          this.showLoading = false
        }
      },
      detailCall(id) {
        const routeData = this.$router.resolve({ path: `/call-io/${id}` })
        window.open(routeData.href, '_blank')
      },
      getTiming(endCallIoTime, createCallIoTime) {
        if (!endCallIoTime) return ''
        const end = moment(endCallIoTime)
        const start = moment(createCallIoTime)
        const duration = moment.duration(end.diff(start))
        return `${pad(duration.hours(), 2, '0')}:${pad(
          duration.minutes(),
          2,
          '0'
        )}:${pad(duration.seconds(), 2, '0')}`
      },
      async fetchResultStatusCall() {
        const response = await CallIoService.getResultStatusCall({
          ticketId: this.item.ticketId,
          typeTicket: this.item.typeCode,
        })
        this.resultStatusCalls = response.data
      },
      async fetchHistory() {
        try {
          const params = {
            page: 1,
            size: 20,
            customerId: this.item.merchantInfo.customerId,
            ticketId: this.item.ticketId,
          }
          const response = await CallIoService.getHistoryCallIo(params)
          console.log(response)
          this.historyCall = response.data.list
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          this.showLoading = true
          const res = await TicketService.getOne({
            ticketId: this.$route.params.id,
          })
          this.item = res.data
          this.item.nameProcessUserReceiver = res.data.processUserReceiver
            ? res.data.processUserReceiver.name
            : ''
          this.item.nameProcessUserSupervisor = res.data.processUserSupervisor
            ? res.data.processUserSupervisor.name
            : ''
          const dataProcessUserFollowers = res.data.processUserFollowers
            ? res.data.processUserFollowers.map(item => item.name)
            : ''
          this.item.nameProcessUserFollowers = dataProcessUserFollowers
            ? dataProcessUserFollowers.join(', ')
            : ''
          this.infoSale = res.data.saleInfo
          this.dataMakerDevice = {
            assNewTestDevice: res.data.assNewTestDevice,
            assReplaceDevice: res.data.assReplaceDevice,
            deviceChange: res.data.deviceChange,
            deviceTest: res.data.deviceTest,
          }
          this.dataMakerDevice.deviceChange.text = 'haha'
          this.dataMakerDevice.deviceTest.text = 'hihi'
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchResult() {
        try {
          this.showLoading = true
          const res = await TicketService.getResult()
          this.dataResult = res.data.map(item => ({
            id: item.code,
            text: item.text,
          }))
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      viewDetail(link) {
        window.open(link, '_blank')
      },
      updateStatus(value) {
        if (this.checkResult === 'Hoàn thành') {
          this.completeItem(value)
        } else if (this.checkResult === 'Đóng hủy') {
          this.cancelItem(value)
        } else if (this.checkResult === 'Tạm hoãn') {
          this.pendingItem(value)
        }
      },
      editManagerInfo() {
        this.$router.push({
          path: `/ticket-edit-manage/${this.$route.params.id}`,
        })
      },
      initAppendix() {
        this.showModalInitAppendix = true
        this.$nextTick(s => this.$bvModal.show('init-appendix'))
      },
      showModalDeviceAssMC() {
        this.showDeviceAssMC = true
        this.$nextTick(s => this.$bvModal.show('device-ass-mc'))
      },
      showModalMaker() {
        this.showModalMakerDeviceAss = true
        this.$nextTick(s => this.$bvModal.show('maker-device-ass'))
      },
      async fetchUserSupervisor() {
        try {
          this.showLoading = true
          const params = {
            typeSales: ['SALE', 'AFTER_SALE', 'TELESALE', 'AFTER_SALE_OFFLINE'],
          }
          const response = await TicketService.getUserSupervisor(params)
          this.dataOption = response.data.map(item => ({
            id: item.id,
            text: `${item.name} - ${item.email}`,
          }))
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async updateInfo(userId) {
        try {
          this.showLoading = true
          const data = {
            ticketId: this.item.ticketId,
            userId: userId,
          }
          const res = await TicketService.sendNotiInitAppendix(data)
          if (res.code === 1000) {
            this.showSuccessMx(`Yêu cầu hỗ trợ lên phụ lục thành công`)
            this.fetchData()
            this.$bvModal.hide('init-appendix')
            this.showModalInitAppendix = false
          } else this.showFailMx(res.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      closeModalRequestDevice() {
        this.$bvModal.hide('init-appendix')
        this.showModalInitAppendix = false
      },
      closeModal() {
        this.$bvModal.hide('device-ass-mc')
        this.showDeviceAssMC = false
      },
      closeModalMaker() {
        this.$bvModal.hide('maker-device-ass')
        this.showModalMakerDeviceAss = false
      },
      handleClick() {
        const baseUrl = window.location.origin
        const ticketId = this.$route.params && this.$route.params.id ? this.$route.params.id : ''

        const url = `${baseUrl}/ticket/add-image?ticketId=${ticketId}`
        if (this.isMobile) {
          window.open(url, '_blank')
        }

        this.showFailMx('Bạn cần thêm ảnh hiện trường bằng app my nextpay')
      },
      checkIsMobile() {
        this.isMobile = window.innerWidth < 768 // Bootstrap md breakpoint
      },
      linkTPVMerchant(check, id) {
        if (check === 1) {
          const url = `/customer-support/tpv-ma/${id}`
          window.open(url, '_blank')
        }
        if (check === 2) {
          const url = `/warranty/${id}`
          window.open(url, '_blank')
        }
        if (check === 3) {
          const url = `/contract-detail-paper/${id}`
          window.open(url, '_blank')
        }
      },
      updateInfoDeviceAssMC() {
        this.fetchData()
        this.closeModal()
      },
      updateInfoMakerDevice() {
        this.fetchData()
        this.closeModalMaker()
      },
    },
  }
</script>
<style scoped>
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .detail {
    cursor: pointer;
    color: blue;
  }

  .text-start {
    text-align: start;
    padding-left: 3px;
  }

  h6 {
    font-weight: 600;
    font-size: 14px;
  }

  .breadcrumb-area {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
  }

  .reason-text {
    white-space: pre-line;
  }

  .form-detail {
    box-shadow: none !important;
  }

  .custom-table,
  .b-table-sticky-header {
    min-height: 100px !important;
  }
</style>
